var e4 = e4 || {},
    junckers = junckers || {};
( function () {
    'use strict';
    jQuery( function () {
        junckers.init();
    } );
    junckers.init = function () {
        junckers.outlet.init();
        junckers.forms.init();
        junckers.casesDetailImagesModal.init();
        junckers.insertDocumentationPdfLink();
        junckers.lazyload.init();
        junckers.MailChimpFormTracking.init();
        junckers.variants.init();
        junckers.certificates.init();
        junckers.highlights.init();
        junckers.woodcareCompare.init();
        junckers.href.init();
        junckers.videoObserver.init();
        junckers.activeCampaign.init();
    };
    
    junckers.activeCampaign = {
      init:  function () {
          junckers.activeCampaign.autoFillProductName();
          junckers.activeCampaign.removeDefaultStyle(); 
      },
      removeDefaultStyle: function () {
          jQuery( '.js-junckers-active-campaign' ).find( 'style' ).remove();
      },
      autoFillProductName: function () {
          var strProductName = jQuery( 'head' ).find( 'title' ).html(), 
              jActiveCampaignProductInput = jQuery( '.js-junckers-active-campaign form' ).find( 'input[data-name="vareprvenavn"]' );
          jActiveCampaignProductInput.val( strProductName );
          jActiveCampaignProductInput.attr( 'readonly', 'readonly' );
      }
    };
    
    junckers.videoObserver = {
        arrVideoElements: null,
        arrVideoIframes: [],
        script: {
            url: '//cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=IntersectionObserver%2CIntersectionObserverEntry&flags=gated',
            callback: null
        },
        isIntersectionObserverSupported: (function(){
            return 'IntersectionObserver' in window;
        })(),
        init: function () {
            junckers.videoObserver.arrVideoElements = jQuery( '.js-junckers-video-observer-element' ).toArray();
            if ( junckers.videoObserver.arrVideoElements.length > 0 ) {
                jQuery.each( junckers.videoObserver.arrVideoElements, function ( intIndex, domElement ) {
                    jQuery( domElement ).data( 'ident', Math.random() );
                } );
                
                if ( junckers.videoObserver.isIntersectionObserverSupported ){
                    junckers.videoObserver.bindEvents();
                } else {
                    e4.util.require.js( junckers.videoObserver.script, function () {
                        junckers.videoObserver.bindEvents();
                    } );
                }
            }
        },
        bindEvents: function () {
            if ( junckers.videoObserver.arrVideoElements.length > 0 ) {
                e4.util.observer.bind( junckers.videoObserver.arrVideoElements, junckers.videoObserver.actionsForEachElement, {
                    root: null,
                    rootMargin: '0px 0px 0px 0px',
                    threshold: 0
                } );
            }
        },
        actionsForEachElement: function ( element, observer ) {
            function elementActions() {
                var jElement = jQuery( element.target );
                if ( element.isIntersecting === true ) {
                    if ( jElement.data( 'provider' ) === 'youtube' && junckers.videoObserver.youtube.ready === false ) {
                        e4.util.require.js( junckers.videoObserver.youtube.script, function () {
                            junckers.videoObserver.youtube.ready = true;
                        } );
                    }
                }
            }
            // check cookie consent before actions
            if($(document.body).data('cookiebot')) {
                window.addEventListener('CookiebotOnConsentReady', function() {
                    if (Cookiebot.consent.marketing) {
                        elementActions();
                    }
                }, false);
            } else {
                elementActions();
            }
        },
        youtube: {
            script: {
                url: '//www.youtube.com/player_api',
                callback: null
            },
            api: null,
            ready: false,
            players: [],
            build: function () {
                jQuery.each( junckers.videoObserver.arrVideoElements, function ( intIndex, domElement ) {
                    var jElement = jQuery( domElement ),
                        player = null;
                    if ( jElement.data( 'provider' ) === 'youtube' ) {
                        player = new YT.Player( jElement.attr( 'id' ), {
                            videoId: jElement.data( 'videoid' ),
                            playerVars: {
                                controls: 1,
                                showinfo: 0,
                                modestbranding: 1,
                                rel: 0,
                                enablejsapi: 1,
                                origin: location.origin
                            }
                        } );
                    }
                    junckers.videoObserver.youtube.players[ jElement.data( 'ident' ) ] = player;
                } );
            }
        },
        vimeo: {}
    };
    junckers.href = {
        init: function () {
            junckers.href.bindEvents();
        },
        bindEvents: function () {
            jQuery( '#dwcontentmain' ).on( 'click', 'a', function ( event ) {
                var domLink = jQuery( event.currentTarget );
                if ( junckers.href.isInternalLink( event.currentTarget ) === true && domLink.attr( 'href' ) !== '' && domLink.attr( 'href' ) !== '#' ) {
                    event.preventDefault();
                    junckers.href.ajax( {
                        method: 'GET',
                        data: {
                            'href': domLink.attr( 'href' )
                        }
                    }, function ( data ) {
                        if ( data.pdfpath.length > 0 ) {
                            window.open( data.pdfpath, '_blank' );
                        }
                        else {
                            if ( domLink.attr( 'target' ) !== undefined && domLink.attr( 'target' ).toLowerCase() === '_blank' ) {
                                window.open( domLink.attr( 'href' ), '_blank' );
                            }
                            else {
                                location.href = domLink.attr( 'href' );
                            }
                        }
                    } );
                }
            } );
        },
        isInternalLink: function ( domLink ) {
            var currentHostname = window.location.hostname;
            var linkHostname = domLink.hostname;
            currentHostname = currentHostname.replace( /^www\./, '' );
            linkHostname = linkHostname.replace( /^www\./, '' );
            return currentHostname === linkHostname;
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: e4.settings.nav.pdflookup.url,
                method: 'POST',
                dataType: 'json',
                cache: true
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        }
    };
    junckers.certificates = {
        init: function () {
            if ( jQuery( '.js-junckers-certificate-popover' ).length > 0 ) {
                jQuery( '[data-toggle="popover"]' ).popover();
            }
        }
    }
    junckers.highlights = {
        init: function () {
            if ( jQuery( '.js-junckers-highlight-popover' ).length > 0 ) {
                jQuery( '[data-toggle="popover"]' ).popover();
            }
        }
    }
    junckers.woodcareCompare = {
        init: function () {
            jQuery( window ).on( 'shown.bs.modal', function () {
                var compareDiv = jQuery( '.js-woodcare-compare-data' ).first().find( '.js-compare-div' );
                var compare_array = [];
                jQuery.each( compareDiv, function ( index, item ) {
                    compare_array.push( jQuery( item ).data( 'row-name' ) );
                } );
                jQuery.each( compare_array, function ( index, item ) {
                    var intHeight = 0;
                    jQuery( '.js-compare-div[data-row-name="' + item + '"]' ).each( function ( intIndex, domElm ) {
                        if ( jQuery( domElm ).height() > intHeight ) {
                            intHeight = jQuery( domElm ).height();
                        }
                    } );
                    console.log( item, intHeight )
                    if ( intHeight < 50 ) {
                        jQuery( '.js-compare-div[data-row-name="' + item + '"]' ).remove();
                    }
                    else {
                        jQuery( '.js-compare-div[data-row-name="' + item + '"]' ).height( intHeight );
                    }
                } );
            } );
        }
    }
    junckers.variants = {
        data: window.jsonProductData,
        readyforInteraction: false,
        init: function () {
            if ( jQuery( '.js-junckers-variant-picker' ).length > 0 ) {
                junckers.variants.bindEvents();
            }
            if ( jQuery( '.junckers-sample-form' ).length > 0 ) {
                junckers.variants.samples.init();
            }
        },
        bindEvents: function () {
            jQuery( '[data-toggle="popover"]' ).popover();
            jQuery( '.js-junckers-variant-picker' ).on( 'change', '.js-junckers-variant-option', function ( event ) {
                jQuery( '[data-toggle="popover"]' ).popover( 'hide' );
                junckers.variants.setAvailableVariantOptions( event );
            } );
            jQuery( '.js-junckers-variant-picker' ).on( 'change', '.js-junckers-extra-features-switch', function ( event ) {
                jQuery( event.target ).closest( '.js-junckers-variant-options' ).find( '.js-junckers-variant-option:not(:checked)' ).prop( 'checked', true ).trigger( 'change' );
            } );
            jQuery( '[data-target="#collapseTwo"]' ).on( 'click', function ( event ) {
                jQuery( '#add-to-cart-button' ).removeClass( 'd-none' );
            } );
            junckers.variants.checkSelectedVariantOptions();
        },
        samples: {
            jModalSampleCheckout: null,
            currentStep: 1,
            toggleSampleCheckoutModalBtn: function(intQuantity){
                if ( intQuantity > 0 ){
                    jQuery('.js-junckers-open-sample-checkout-modal').removeClass('d-none');
                } else {
                    jQuery('.js-junckers-open-sample-checkout-modal').addClass('d-none');
                }
            },
            init: function(){
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-junckers-sample-checkout-orderlines' );
                    junckers.variants.samples.jModalSampleCheckout = jQuery('#sampleCheckoutModal');
                    junckers.variants.samples.privacyPolicy.init();
                    
                    var jqXHR = jQuery.ajax( {
                        url: e4.settings.ecom.samplecart.url,
                        method: 'POST',
                        dataType: 'json',
                        cache: false,
                    } );
                    jqXHR.done( function ( data ) {
                        junckers.variants.samples.toggleSampleCheckoutModalBtn(data.cart.totalProductQuantity);
                        junckers.variants.samples.bindEvents();
                    } );
                } );
                
            },
            bindEvents: function () {
                jQuery( '.junckers-sample-form' ).on( 'change', '.js-variantid-picker', function ( event ) {
                    if ( jQuery( event.target ).val() != '' ) {
                        jQuery( '.junckers-sample-form' ).find( '.js-sample-buy-btn' ).removeClass( 'd-none' );
                    }
                    else {
                        jQuery( '.junckers-sample-form' ).find( '.js-sample-buy-btn' ).addClass( 'd-none' );
                    }
                } );
                jQuery('.js-junckers-open-sample-checkout-modal').on('click', function ( event ){
                    event.preventDefault();
                    var jqXHR = jQuery.ajax( {
                        url: e4.settings.ecom.samplecart.url,
                        method: 'POST',
                        dataType: 'json',
                        cache: false,
                    } );
                    jqXHR.done( function ( data ) {
                        if ( data.cart.totalProductQuantity > 0 ){
                            junckers.variants.samples.currentStep = 2;
                            junckers.variants.samples.jModalSampleCheckout.find( '.js-junckers-sample-checkout-orderlines' ).html( e4.handlebars.tmpl.junckersSampleCheckoutOrderlines( data ) );
                            junckers.variants.samples.setStep(junckers.variants.samples.currentStep);
                            junckers.variants.samples.jModalSampleCheckout.modal('show');
                        }
                    } );
                });
                
                jQuery(document).on('submit', '.js-junckers-sample-form', function(event){
                    event.preventDefault();
                    junckers.variants.samples.addToCart(event);
                });

                junckers.variants.samples.jModalSampleCheckout
                .on('click', '.js-junckers-sample-checkout-next-step', function(event){
                    event.preventDefault();
                    junckers.variants.samples.currentStep = 2;
                    junckers.variants.samples.setStep(junckers.variants.samples.currentStep);
                })
                .on('click', '.js-junckers-sample-checkout-close-modal-btn', function(event){
                    event.preventDefault();
                    junckers.variants.samples.currentStep = 1;
                    junckers.variants.samples.setStep(junckers.variants.samples.currentStep);
                    junckers.variants.samples.jModalSampleCheckout.modal('hide');
                    
                })
                .on('click', '.js-e-checkout-approve-order', function(event){
                    event.preventDefault();
                    var jForm = jQuery(event.target.form);
                    jForm.validate();
                    if ( jForm.valid() === true ) {
                        junckers.variants.samples.signUpForActiveCampaign(jForm);
                        var jqXHR = jQuery.ajax( {
                            url: e4.settings.ecom.samplecheckout.url,
                            method: 'POST',
                            dataType: 'json',
                            data: jForm.serialize(),
                            cache: false,
                        } );
                        jqXHR.done( function ( data ) {
                            console.log('__checkout.submit.done', data);
                            if ( data.orderIsCompleted ){
                                junckers.variants.samples.jModalSampleCheckout.find( '.js-junckers-sample-checkout-orderlines' ).html( e4.handlebars.tmpl.junckersSampleCheckoutOrderlines( data ) );
                                jQuery('.js-junckers-samples-checkout-form').addClass('d-none');
                                window.localStorage.setItem('sample.checkout.form.values', JSON.stringify(jForm.serializeArray()));
                            }

                            if ( data.cart.totalProductQuantity > 0 ){
                                jQuery('.js-junckers-open-sample-checkout-modal').removeClass('d-none');
                            } else {
                                jQuery('.js-junckers-open-sample-checkout-modal').addClass('d-none');
                            }
                        } );
                    }
                })
                .on( 'change', '.js-e-checkout-toggle-field', function ( event ) {
                    event.preventDefault();
                    var jToggleField = jQuery( this ).val(),
                        jTarget = jQuery( '.js-e-checkout-toggle-target[data-target="' + jToggleField + '"]' );
                    jTarget.slideToggle( e4.settings.animation.speed );
                    if ( jQuery( this ).is( ':checked' ) === false ) {
                        jTarget.find( 'input, textarea' ).val( '' );
                    }
                } )
                .on('submit', '.js-junckers-samples-orderline-delete-form', function(event){
                    event.preventDefault();
                    junckers.variants.samples.removeFromCart(event);
                });
            },
            signUpForActiveCampaign: function(jForm){
                jForm = jForm === undefined ? jQuery('.js-e-checkout-approve-order').closest('form') : jForm;
                var acFormContainer = jQuery('.js-junckers-active-campaign-modal');
                if ( acFormContainer.length > 0 ){
                    acFormContainer.find('input[name="fullname"]').val(jForm.find('input[name="EcomOrderDeliveryName"]').val());
                    acFormContainer.find('input[name="phone"]').val(jForm.find('input[name="EcomOrderDeliveryPhone"]').val());
                    acFormContainer.find('input[name="email"]').val(jForm.find('input[name="EcomOrderCustomerEmail"]').val());
                    acFormContainer.find('button').trigger('click');
                }
            },
            privacyPolicy: {
                init: function () {
                    junckers.variants.samples.privacyPolicy.bindEvents();
                    junckers.variants.samples.privacyPolicy.get();
                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout' ).on( 'change', 'input[name="EcomOrderCustomerAccepted"]', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', jQuery( this ).prop( 'checked' ) );
                    } );
                    jQuery( '.js-e-accept-privacy-policy' ).on( 'click', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', true );
                    } );
                },
                get: function () {
                    jQuery.get( e4.settings.ecom.checkout.privacyPolicy, function ( data ) {
                        var jHtml = jQuery( data ).find( '.e-content-main' ).html();
                        jQuery( '.js-e-checkout-modal-privacy-policy-body' ).replaceWith( jHtml );
                    } );
                }
            },
            removeFromCart: function(event){
                var jqXHR = jQuery.ajax( {
                    url: e4.settings.ecom.samplecart.url,
                    method: 'POST',
                    dataType: 'json',
                    data: jQuery(event.currentTarget).serialize(),
                    cache: false,
                } );
                jqXHR.done( function ( data ) {
                    junckers.variants.samples.toggleSampleCheckoutModalBtn(data.cart.totalProductQuantity);
                    junckers.variants.samples.currentStep = 2;
                    junckers.variants.samples.jModalSampleCheckout.find( '.js-junckers-sample-checkout-orderlines' ).html( e4.handlebars.tmpl.junckersSampleCheckoutOrderlines( data ) );
                    junckers.variants.samples.setStep(junckers.variants.samples.currentStep);
                    if ( data.cart.totalProductQuantity === 0 ){
                        junckers.variants.samples.jModalSampleCheckout.modal('hide');
                    }
                } );
            },
            addToCart: function(event){
                var jqXHR = jQuery.ajax( {
                    url: e4.settings.ecom.samplecart.url,
                    method: 'POST',
                    dataType: 'json',
                    data: jQuery(event.currentTarget).serialize(),
                    cache: false,
                } );
                jqXHR.done( function ( data ) {
                    junckers.variants.samples.toggleSampleCheckoutModalBtn(data.cart.totalProductQuantity);
                    junckers.variants.samples.currentStep = 1;
                    junckers.variants.samples.jModalSampleCheckout.find( '.js-junckers-sample-checkout-orderlines' ).html( e4.handlebars.tmpl.junckersSampleCheckoutOrderlines( data ) );
                    junckers.variants.samples.setStep(junckers.variants.samples.currentStep);
                    junckers.variants.samples.jModalSampleCheckout.modal('show');
                    junckers.variants.samples.setFormInputValues();
                } );
            },
            setStep: function(intStep){
                if ( intStep === 1 ){
                    junckers.variants.samples.jModalSampleCheckout.find('.js-junckers-modal-samples-checkout-step[data-step="1"]').removeClass('d-none');
                    junckers.variants.samples.jModalSampleCheckout.find('.js-junckers-modal-samples-checkout-step[data-step="2"]').addClass('d-none');
                    if ( !junckers.variants.samples.jModalSampleCheckout.find('.modal-dialog').hasClass('modal-sm') ){
                        junckers.variants.samples.jModalSampleCheckout.find('.modal-dialog').addClass('modal-sm');
                    }
                } else if(intStep === 2){
                    junckers.variants.samples.jModalSampleCheckout.find('.js-junckers-modal-samples-checkout-step[data-step="1"]').addClass('d-none');
                    junckers.variants.samples.jModalSampleCheckout.find('.js-junckers-modal-samples-checkout-step[data-step="2"]').removeClass('d-none');
                    if ( junckers.variants.samples.jModalSampleCheckout.find('.modal-dialog').hasClass('modal-sm') ){
                        junckers.variants.samples.jModalSampleCheckout.find('.modal-dialog').removeClass('modal-sm');
                    }
                    
                }
            },
            setFormInputValues: function(){
                var arrayFormFields = JSON.parse(window.localStorage.getItem('sample.checkout.form.values'));
                jQuery.each(arrayFormFields, function(intIndex, objData){
                    junckers.variants.samples.jModalSampleCheckout.find('input[type="Text"][name="'+objData.name+'"]').val(objData.value);
                });
            }
        },
        checkSelectedVariantOptions: function () {
            jQuery( '.js-junckers-variant-picker' ).find( '.js-junckers-variant-option:checked' ).each( function ( intIndex, element ) {
                jQuery( element ).trigger( 'change' );
            } );
            junckers.variants.readyforInteraction = true;
        },
        setAvailableVariantOptions: function ( event ) {
            var jFirstCheckedElement = jQuery( '.js-junckers-variant-picker' ).find( '.js-junckers-variant-option:checked' ).first(),
                jElement = event === undefined ? jFirstCheckedElement : jQuery( event.target ),
                dataVariantcombinations = junckers.variants.data.variantcombinations,
                jElementVariantOptionsContainer = jQuery( '.js-junckers-variant-options' ),
                intStartIndex = jElementVariantOptionsContainer.index( jElement.closest( '.js-junckers-variant-options' ) ),
                intQuantity = jQuery( '.js-e-product-form' ).find( '.js-junckers-quantity' ).val();
            jElementVariantOptionsContainer.each( function ( intIndex, element ) {
                if ( intStartIndex >= intIndex ) {
                    var strValue = jQuery( element ).find( 'input:checked' ).val();
                    dataVariantcombinations = jQuery.grep( dataVariantcombinations, function ( element, intIndex ) {
                        return element.variantid.includes( strValue ); // && intQuantity <= element.stock
                    } );
                }
            } );
            jElementVariantOptionsContainer.each( function ( intIndex, element ) {
                if ( intStartIndex < intIndex ) {
                    jQuery( element ).find( '.js-junckers-variant-option' ).each( function ( intIndex, element ) {
                        var jElement = jQuery( element ),
                            strValue = jElement.val(),
                            boolDisabled = jQuery.grep( dataVariantcombinations, function ( element, intIndex ) {
                                return element.variantid.includes( strValue );
                            } ).length === 0;
                        jElement.prop( 'disabled', boolDisabled );
                        if ( boolDisabled && jElement.is( ':checked' ) ) {
                            if ( jElement.closest( '.js-junckers-step' ).hasClass( 'show' ) ) {
                                if ( jElement.is( ':visible' ) ) {
                                    jElement.popover( 'show' );
                                    jQuery( '#' + jElement.attr( 'aria-describedby' ) ).addClass( 'junckers-product-popover' );
                                }
                                else {
                                    var jExtraFeatureSwitch = jElement.closest( '.js-junckers-variant-options' ).find( '.js-junckers-extra-features-switch' );
                                    jExtraFeatureSwitch.popover( 'show' );
                                    jQuery( '#' + jExtraFeatureSwitch.attr( 'aria-describedby' ) ).addClass( 'junckers-product-popover' );
                                }
                            }
                        }
                        else {
                            if ( jElement.is( ':visible' ) ) {
                                jElement.popover( 'hide' );
                            }
                        }
                    } );
                }
            } );
            junckers.variants.updateDetail();
        },
        updateDetail: function () {
            var selectedVariantID = junckers.variants.getSelectedVariantID(),
                intQuantity = jQuery( '.js-e-product-form' ).find( '.js-junckers-quantity' ).val();
            var variantCombination = jQuery.grep( junckers.variants.data.variantcombinations, function ( element, intIndex ) {
                return element.variantid === selectedVariantID; // && intQuantity <= element.stock
            } );
            if ( variantCombination.length > 0 ) {
                junckers.variants.enableNextStep( variantCombination );
            }
            else {
                junckers.variants.disableNextStep();
            }
        },
        getSelectedVariantID: function () {
            var arrVariantComboID = [];
            jQuery( '.js-junckers-variant-options' ).each( function ( intIndex, element ) {
                arrVariantComboID[ jQuery( element ).data( 'groupindex' ) ] = jQuery( element ).find( '.js-junckers-variant-option:checked' ).val();
            } );
            return arrVariantComboID.join( '.' );
        },
        enableNextStep: function ( variantCombination ) {
            e4.product.outlet.outletForm.find( '.js-total-outlet-price' ).data( 'basicprice', variantCombination[ 0 ].price );
            e4.product.outlet.basicPricePerM2 = e4.product.outlet.outletForm.find( '.js-total-outlet-price' ).data( 'basicprice' );
            e4.product.outlet.outletForm.find( '.js-junckers-goal-sqm' ).trigger( 'change' );
            jQuery( '.js-junckers-productid' ).val( variantCombination[ 0 ].id );
            jQuery( '.js-junckers-variantid' ).val( variantCombination[ 0 ].variantid );
            var jContainerBuy = jQuery( '.js-junckers-container-buy' ),
                jContainerAlert = jQuery( '.js-junckers-container-alert' );
            jContainerBuy.addClass( 'd-flex' );
            jContainerBuy.removeClass( 'd-none' );
            jContainerAlert.addClass( 'd-none' );
            jQuery( 'button[data-target="#collapseOne"]' ).prop( 'disabled', false );
            jQuery( 'a[data-target="#collapseOne"]' ).removeClass( 'd-none' );
            jQuery( 'a[data-target="#collapseOne"]' ).addClass( 'd-block' );
            jQuery( 'button[data-target="#collapseTwo"]' ).prop( 'disabled', false );
            jQuery( 'a[data-target="#collapseTwo"]' ).removeClass( 'd-none' );
            jQuery( 'a[data-target="#collapseTwo"]' ).addClass( 'd-block' );
            jQuery( '.popover.show' ).popover( 'hide' );
            junckers.variants.modifyMaxQuantity( variantCombination );
        },
        disableNextStep: function () {
            var jContainerBuy = jQuery( '.js-junckers-container-buy' ),
                jContainerAlert = jQuery( '.js-junckers-container-alert' );
            jContainerBuy.removeClass( 'd-flex' );
            jContainerBuy.addClass( 'd-none' );
            console.log( 'jContainerBuy', jContainerBuy.attr( 'class' ) );
            jContainerAlert.removeClass( 'd-none' );
            jQuery( 'button[data-target="#collapseOne"]' ).prop( 'disabled', true );
            jQuery( 'a[data-target="#collapseOne"]' ).addClass( 'd-none' );
            jQuery( 'a[data-target="#collapseOne"]' ).removeClass( 'd-block' );
            jQuery( 'button[data-target="#collapseTwo"]' ).prop( 'disabled', true );
            jQuery( 'a[data-target="#collapseTwo"]' ).addClass( 'd-none' );
            jQuery( 'a[data-target="#collapseTwo"]' ).removeClass( 'd-block' );
        },
        modifyMaxQuantity: function ( variantCombination ) {
            var jInputSqm = jQuery( '.js-junckers-goal-sqm' );
            jInputSqm.attr( 'max', variantCombination[ 0 ].stock );
            if ( variantCombination[ 0 ].stock < jInputSqm.val() ) {
                var strPlaceholderContent = jInputSqm.data( 'placeholderContent' );
                jInputSqm.attr( 'data-content', strPlaceholderContent.replace( '{maxStock}', variantCombination[ 0 ].stock ) );
                jInputSqm.popover( 'show' );
                jQuery( '#' + jInputSqm.attr( 'aria-describedby' ) ).addClass( 'junckers-product-popover' );
                junckers.variants.disableNextStep();
            }
        }
    };
    junckers.outlet = {
        init: function () {
            junckers.outlet.bindEvents();
        },
        bindEvents: function () {
            var productPage = jQuery( '.js-e-product' );
            productPage.on( 'click', '.js-outlet-choose-accessory', function ( event ) {
                if ( jQuery( event.target ).find( '.js-outlet-checkbox' ).prop( 'checked' ) ) {
                    productPage.find( '.js-remove-accessories' ).trigger( 'click' );
                    return false;
                }
                jQuery( event.target ).find( 'input[type="checkbox"], input[type="radio"]' ).trigger( 'click' );
                if ( jQuery( '.js-e-product input:checked' ).length > 0 ) {
                    jQuery( '.js-remove-accessories-container' ).removeClass( 'd-none' );
                }
                else {
                    jQuery( '.js-remove-accessories-container' ).addClass( 'd-none' );
                }
            } );
            productPage.on( 'click', '.js-remove-accessories', function () {
                jQuery( '.js-outlet-choose-accessory-container' ).find( 'input[type="checkbox"]:checked, input[type="radio"]:checked' ).prop( 'checked', false );
                jQuery( '.js-remove-accessories-container' ).addClass( 'd-none' );
                e4.product.outlet.calculate();
            } );
        }
    };
    junckers.MailChimpFormTracking = {
        init: function () {
            junckers.MailChimpFormTracking.cookiebotIsActive();
        },
        cookiebotIsActive: function () {
            var strHasCookiebot = jQuery( 'body' ).data( 'cookiebot' );
            if ( strHasCookiebot === 'true' ) {
                junckers.MailChimpFormTracking.cookiebotStatisticsConsentGiven();
            }
            else {
                junckers.MailChimpFormTracking.validate();
            }
        },
        cookiebotStatisticsConsentGiven: function () {
            if ( Cookiebot.consent.statistics === true ) {
                junckers.MailChimpFormTracking.validate();
            }
        },
        validate: function () {
            var jsMailChimpForm = jQuery( 'form#mc-embedded-subscribe-form' );
            jsMailChimpForm.on( 'submit', function ( e ) {
                var boolIsValid = true;
                jQuery.each( jQuery( 'form#mc-embedded-subscribe-form input.required' ), function ( index, value ) {
                    if ( !jQuery( value ).val() ) {
                        boolIsValid = false;
                    }
                } );
                if ( boolIsValid ) {
                    junckers.MailChimpFormTracking.dataLayer();
                }
            } );
        },
        dataLayer: function () {
            dataLayer.push( {
                'eventCategory': 'Newsletter',
                'eventAction': 'Signup',
                'eventLabel': location.href,
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
        }
    };
    junckers.lazyload = {
        init: function () {
            junckers.lazyload.isRAF = false;
            junckers.lazyload.bindLazyloading.init();
        },
        bindLazyloading: {
            init: function () {
                junckers.lazyload.bindLazyloading.viewport();
                junckers.lazyload.bindLazyloading.carousel();
                junckers.lazyload.bindLazyloading.megamenuParagraphs();
                junckers.lazyload.bindLazyloading.banner();
                junckers.lazyload.bindLazyloading.productlist();
            },
            viewport: function () {
                jQuery( window ).on( 'load scroll resize', junckers.lazyload.bindRAF );
            },
            carousel: function () {
                var firstCarouselElement = jQuery( '.js-carousel-lazyload-item' ).filter( ':first-child' );
                junckers.lazyload.loadImage( firstCarouselElement.get( 0 ) );
                jQuery( '.js-carousel-lazyload' ).on( 'slide.bs.carousel', function ( event ) {
                    junckers.lazyload.loadImage( event.relatedTarget );
                } );
            },
            megamenuParagraphs: function () {
                jQuery( '.e-dropdown-mega' ).on( 'shown.bs.dropdown', function ( event ) {
                    var targetDropdownMenuId = jQuery( event.relatedTarget ).data( 'collapse-target' );
                    if ( jQuery( targetDropdownMenuId ).is( '.e-megamenu-paragraphs' ) === true ) {
                        junckers.lazyload.loadImagesInViewport();
                    }
                } );
                
                jQuery( '.e-dropdown-mega' ).on( 'show.bs.dropdown', function ( event ) {
                    var targetDropdownMenuId = jQuery( event.relatedTarget ).data( 'collapse-target' );
                    if ( jQuery( targetDropdownMenuId ).is( '.e-megamenu-paragraphs' ) === true ) {
                        junckers.lazyload.bindLazyloading.getPageContent( jQuery( targetDropdownMenuId ).find( '.js-junckers-megamenu-paragraphs' ) );
                        junckers.lazyload.loadImagesInViewport();
                    }
                } );
            },
            getPageContent: function ( jElement ) {
                if ( jQuery.trim( jElement.text() ).length === 0 && jQuery.isNumeric( jElement.data( 'pageId' ) ) ) {
                    var jqXHR = jQuery.ajax( {
                        url: e4.settings.nav.pagecontent.url,
                        method: 'POST',
                        dataType: 'html',
                        data: {
                            'pageid': jElement.data( 'pageId' )
                        },
                        cache: true
                    } );
                    jqXHR.done( function ( html ) {
                        jElement.html( html );
                        setTimeout( function () {
                            junckers.lazyload.loadImagesInViewport()
                        }, 300 );
                    } );
                }
            },
            banner: function () {
                jQuery( document ).on( 'animatein.e4.banner', function ( event, domElm ) {
                    junckers.lazyload.loadImage( domElm );
                } );
            },
            productlist: function () {
                jQuery( '.js-e-productlist' ).on( 'builded.e4.productlist', function () {
                    junckers.lazyload.loadImagesInViewport();
                } );
            }
        },
        unbindViewportLazyloading: function () {
            jQuery( window ).off( 'load scroll resize', junckers.lazyload.bindRAF );
        },
        getLazyImageCount: function () {
            return jQuery( '.js-image-lazyloading' ).length;
        },
        bindRAF: function () {
            if ( junckers.lazyload.isRAF === false ) {
                window.requestAnimationFrame( function () {
                    junckers.lazyload.loadImagesInViewport();
                    junckers.lazyload.isRAF = false;
                } );
            }
            junckers.lazyload.isRAF = true;
        },
        loadImagesInViewport: function () {
            jQuery( '.js-image-lazyloading' ).each( function ( index, domElm ) {
                var jThis = jQuery( domElm );
                //if ( e4.util.isInViewport( jThis ) === true ) {
                    junckers.lazyload.loadImage( domElm );
                    jThis.removeClass( 'js-image-lazyloading image-lazyloading' );
                    if ( junckers.lazyload.getLazyImageCount() === 0 ) {
                        junckers.lazyload.unbindViewportLazyloading();
                    }
                //}
            } );
        },
        loadImage: function ( domElm ) {
            var jImage = jQuery( domElm ),
                strDataSrc = jImage.data( 'src' ),
                strDataSrcSet = jImage.data( 'srcset' );
            if ( jImage.is( 'img' ) === true ) {
                if ( strDataSrc !== undefined ) {
                    jImage.attr( 'src', strDataSrc );
                }
                if ( strDataSrcSet !== undefined ) {
                    jImage.attr( 'srcset', strDataSrcSet );
                }
            }
            else {
                if ( strDataSrcSet !== undefined ) {
                    var imageSrcSetArr = strDataSrcSet.split( ',' );
                    strDataSrc = junckers.lazyload.backgroundImageSrcset.get( imageSrcSetArr, jQuery( window ).width() );
                }
                jImage.css( 'background-image', 'url(' + strDataSrc + ')' );
            }
        },
        backgroundImageSrcset: {
            get: function ( imageSrcSetArr, windowWidth ) {
                imageSrcSetArr = imageSrcSetArr.filter( function ( element ) {
                    return element !== '';
                } );
                var srcsetSplitStr = junckers.lazyload.backgroundImageSrcset.splitSrcsetStr( imageSrcSetArr[ imageSrcSetArr.length - 1 ] ),
                    maxWidth = junckers.lazyload.backgroundImageSrcset.getWidth( srcsetSplitStr[ 1 ] ),
                    returnSrcsetItem = srcsetSplitStr[ 0 ];
                for ( var i = 0; i < imageSrcSetArr.length; i++ ) {
                    var srcsetItemArr = junckers.lazyload.backgroundImageSrcset.splitSrcsetStr( imageSrcSetArr[ i ] ),
                        srcsetItemWidth = junckers.lazyload.backgroundImageSrcset.getWidth( srcsetItemArr[ 1 ] );
                    if ( srcsetItemWidth >= windowWidth && srcsetItemWidth < maxWidth ) {
                        maxWidth = srcsetItemWidth;
                        returnSrcsetItem = srcsetItemArr[ 0 ];
                    }
                }
                return returnSrcsetItem;
            },
            getWidth: function ( srcsetStr ) {
                return parseInt( srcsetStr.replace( 'w', '' ) );
            },
            splitSrcsetStr: function ( srcsetStr ) {
                return srcsetStr.split( ' ' );
            }
        }
    };
    
    junckers.forms = {
        init: function () {
            junckers.forms.setSubmitPageName();
            junckers.forms.mailchimpSetSubmitPageName();
            junckers.forms.floorCalculator.bindEvents();
        },
        setSubmitPageName: function () {
            jQuery( '.js-e-form-dw' ).find( 'input[name="SubmitPageName"]' ).val( document.getElementsByTagName( 'title' )[ 0 ].innerHTML );
            jQuery( '.js-e-form-dw' ).find( 'input[name="SubmitPageName"]' ).attr( 'readonly', true );
            if ( jQuery( '.js-e-product' )[ 0 ] ) {
                if ( jQuery( '#mc-embedded-subscribe-form' ).length ) {
                    //If productpage has mailchimp form:
                    jQuery( '.junckers-btn-get-quote' ).click( function () {
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '#mc-embedded-subscribe-form' ) );
                    } );
                }
                else if ( jQuery( '.js-e-form-dw' ).length ) {
                    //If productpage has dw-form:
                    jQuery( '.junckers-btn-get-quote' ).click( function () {
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-form-dw' ) );
                    } );
                }
                else {
                    //If productpage has no form:
                    jQuery( '.junckers-btn-get-quote' ).addClass( 'd-none' );
                }
            }
        },
        mailchimpSetSubmitPageName: function () {
            jQuery( '.mc-field-group' ).find( 'input[id="mce-WEBPAGE"]' ).val( document.getElementsByTagName( 'title' )[ 0 ].innerHTML );
            jQuery( '.mc-field-group' ).find( 'input[id="mce-WEBPAGE"]' ).attr( 'readonly', true );
        },
        floorCalculator: {
            timeout: null,
            bindEvents: function () {
                jQuery( '.js-floor-calculator-user-input' ).on( 'input', function ( event ) {
                    if ( junckers.forms.floorCalculator.timeout !== null ) {
                        clearTimeout( junckers.forms.floorCalculator.timeout );
                        junckers.forms.floorCalculator.timeout = null;
                    }
                    junckers.forms.floorCalculator.timeout = setTimeout( function () {
                        var intOutput = junckers.forms.floorCalculator.calc( event.target.value );
                        jQuery( '.js-floor-calculator-output' ).val( isNaN( intOutput ) ? '' : intOutput );
                    }, 500 );
                } );
            },
            calc: function ( userInput ) {
                return ( ( userInput - ( ( ( ( Math.ceil( ( userInput - 86 ) / 40 ) ) ) * 40 ) + 20 ) ) / 2 ) * 10;
            }
        }
    };
    junckers.casesDetailImagesModal = {
        init: function () {
            jQuery( 'div[data-slide-to]' ).on( 'click', function () {
                jQuery( '#js-e-product-image-modal' ).carousel( $( this ).data( 'slide-to' ) );
            } );
        }
    };
    junckers.insertDocumentationPdfLink = function () {
        var strPDFlink = '',
            jPDFlink = jQuery( '.js-junckers-documentation-link' ),
            jDocument = jQuery( 'body' );
        if ( jDocument.length === 1 ) {
            strPDFlink = jDocument.data( 'pdf' );
        }
        if ( !strPDFlink ) {
            strPDFlink = jQuery( '#js-junckers-case-documentation-link-value' ).val();
        }
        if ( strPDFlink ) {
            jPDFlink.attr( 'href', strPDFlink );
            jPDFlink.addClass( 'is-visible' );
        }
    };
    junckers.pdf = {
        url: {
            host: 'http://pdfservice.junckers.espresso4.dk',
            parameters: {
                header: 'https://www.junckers.dk/system/data/pdf-header-product?layouttemplate=designs/junckers/junckers-pdf.cshtml',
                footer: 'https://www.junckers.dk/system/data/pdf-footer?layouttemplate=designs/junckers/junckers-pdf.cshtml',
                content: location.href,
                static: [
                    'header_height=20',
                    'footer_height=25',
                    'pageinfo_show=true',
                    'pageinfo_mask=' + encodeURIComponent( '{0} / {1}' ),
                    'pageinfo_fontsize=3',
                    'mode=chrome'
                ]
            }
        },
        init: function () {
            junckers.pdf.bindEvents();
        },
        bindEvents: function () {
            jQuery( document ).on( 'click', '.js-junkers-pdf-link', function ( event ) {
                event.preventDefault();
                junckers.pdf.open( event.target );
            } );
        },
        open: function ( domNode ) {
            var strUrl = junckers.pdf.getUrlByDomNode( domNode );
            window.open( strUrl );
        },
        getUrlByDomNode: function ( domNode ) {
            var strReturnValue = junckers.pdf.url.host,
                jLink = jQuery( domNode ),
                objLinkData = jLink.data(),
                strProductId = e4.util.stringify( objLinkData.productId ),
                strPageId = e4.util.stringify( objLinkData.pageId ),
                strUrlHeader = junckers.pdf.url.parameters.header,
                strUrlFooter = junckers.pdf.url.parameters.footer,
                strUrlContent = junckers.pdf.url.parameters.content.indexOf( '?' ) === -1 ? junckers.pdf.url.parameters.content + '?pdfgeneratorworking=true' : junckers.pdf.url.parameters.content + '&pdfgeneratorworking=true',
                arrPdfUrlParameters = junckers.pdf.url.parameters.static;
            if ( strProductId !== undefined && strProductId !== '' ) {
                strUrlHeader = strUrlHeader + '&ProductID=' + strProductId;
                strUrlFooter = strUrlFooter + '&ProductID=' + strProductId;
            }
            else if ( strPageId !== undefined && strPageId !== '' ) {
                strUrlHeader = strUrlHeader + '&PageID=' + strPageId;
                strUrlFooter = strUrlFooter + '&PageID=' + strPageId;
            }
            arrPdfUrlParameters.push( 'header_url=' + encodeURIComponent( strUrlHeader ) );
            arrPdfUrlParameters.push( 'footer_url=' + encodeURIComponent( strUrlFooter ) );
            arrPdfUrlParameters.push( 'printurl=' + encodeURIComponent( strUrlContent ) );
            return strReturnValue + '?' + arrPdfUrlParameters.join( '&' );
        }
    };
}() );

function onYouTubePlayerAPIReady() {
    junckers.videoObserver.youtube.build();
};
